export const getLessonPreviewData = (lesson: any, course: any) => {
  const lessonTitle = lesson.title;
  const currentLesson = lesson.order;
  const lessonsCount =
    course.structure === 'LESSONS'
      ? course.lessons.length
      : course.modules.find((module: any) => module.id === lesson.moduleId)
          .lessons.length;

  return { lessonTitle, currentLesson, lessonsCount };
};
